var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#9b9b9b",
    strokeWidth: 0.7,
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "#9b9b9b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13.308 10.882 L 19.751 3.395 L 18.224 3.395 L 12.63 9.897 L 8.162 3.395 L 3.008 3.395 L 9.764 13.228 L 3.008 21.08 L 4.534 21.08 L 10.442 14.213 L 15.161 21.08 L 20.314 21.08 L 13.308 10.882 Z M 11.215 13.314 L 10.531 12.334 L 5.086 4.543 L 7.43 4.543 L 11.826 10.83 L 12.51 11.811 L 18.225 19.983 L 15.879 19.983 L 11.215 13.314 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.246c23db8c7cf6c05f12c2ebd9890054.svg";
export { ForwardRef as ReactComponent };